import { render, staticRenderFns } from "./ErrorReports.vue?vue&type=template&id=2355ed6c&"
import script from "./ErrorReports.vue?vue&type=script&lang=js&"
export * from "./ErrorReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports